var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BA8E8",
    d: "M18 0A17.716 17.716 0 00.5 17.5 17.716 17.716 0 0018 35a17.716 17.716 0 0017.5-17.5A17.716 17.716 0 0018 0zm10 18.75h-8.75v8.75h-2.5v-8.75H8v-2.5h8.75V7.5h2.5v8.75H28v2.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleBlue);
export default ForwardRef;